import { render, staticRenderFns } from "./CreateDataSim.vue?vue&type=template&id=01730b32"
import script from "./CreateDataSim.vue?vue&type=script&lang=js"
export * from "./CreateDataSim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports